// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see OutOfNetworkSponsorShownWelcomeScreenStartEvent
 */
export var OutOfNetworkSponsorShownWelcomeScreenStart = function (_a) {
    var deeplinkPayload = _a.deeplinkPayload, whoInvited = _a.whoInvited;
    return ({
        name: "OutOfNetworkSponsor ShownWelcomeScreen Start",
        parameters: {
            cdf_entity: "OutOfNetworkSponsor",
            cdf_action: "ShownWelcomeScreen",
            deeplink_payload: deeplinkPayload !== undefined && deeplinkPayload !== null ? deeplinkPayload.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            who_invited: whoInvited !== undefined && whoInvited !== null ? whoInvited.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see OutOfNetworkSponsorShownWelcomeScreenProceedWithPrefilledAliasEvent
 */
export var OutOfNetworkSponsorShownWelcomeScreenProceedWithPrefilledAlias = function (_a) {
    var deeplinkPayload = _a.deeplinkPayload, whoInvited = _a.whoInvited;
    return ({
        name: "OutOfNetworkSponsor ShownWelcomeScreen ProceedWithPrefilledAlias",
        parameters: {
            cdf_entity: "OutOfNetworkSponsor",
            cdf_action: "ShownWelcomeScreen",
            deeplink_payload: deeplinkPayload !== undefined && deeplinkPayload !== null ? deeplinkPayload.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            who_invited: whoInvited !== undefined && whoInvited !== null ? whoInvited.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see OutOfNetworkSponsorShownWelcomeScreenExitEvent
 */
export var OutOfNetworkSponsorShownWelcomeScreenExit = function (_a) {
    var deeplinkPayload = _a.deeplinkPayload, whoInvited = _a.whoInvited;
    return ({
        name: "OutOfNetworkSponsor ShownWelcomeScreen Exit",
        parameters: {
            cdf_entity: "OutOfNetworkSponsor",
            cdf_action: "ShownWelcomeScreen",
            deeplink_payload: deeplinkPayload !== undefined && deeplinkPayload !== null ? deeplinkPayload.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            who_invited: whoInvited !== undefined && whoInvited !== null ? whoInvited.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
